import { Link, useLocation } from 'react-router-dom'
import { Zap, Plus } from 'lucide-react'
import { useCredits } from '../../hooks/useCredits.js'
import { useAuthStore } from '../../stores/authStore.js'
import { hasUstsAutoProjectAccess } from '../../features/auto-projects/utils/organizationAccess.js'
import NotificationsMenu from '../notifications/NotificationsMenu.jsx'
import AnnouncementsBell from '../announcements/AnnouncementsBell.jsx'
import ThemeSwitcher from './ThemeSwitcher.jsx'

// Titre selon le début de l'adresse (le plus long préfixe qui correspond l'emporte).
const PAGE_TITLES = {
  '/dashboard': 'Tableau de bord',
  '/dashboard/prospection': 'Prospection',
  '/dashboard/crm': 'CRM',
  '/dashboard/communication': 'Communication',
  '/dashboard/serge-projects': 'Offre',
  '/dashboard/contrats': 'Contrats',
  '/dashboard/compte': 'Compte',
}

function titleFor(pathname) {
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname]
  const prefix = Object.keys(PAGE_TITLES)
    .filter((p) => p !== '/dashboard' && pathname.startsWith(`${p}/`))
    .sort((a, b) => b.length - a.length)[0]
  return prefix ? PAGE_TITLES[prefix] : 'Dashboard'
}

export default function Topbar() {
  const location = useLocation()
  const { credits, isLoading } = useCredits()
  const authUser = useAuthStore((state) => state.user)
  const canAccessAutoProjects = hasUstsAutoProjectAccess(authUser)

  const pageTitle = titleFor(location.pathname)

  return (
    <div className="topbar">
      <h1 className="page-title">{pageTitle}</h1>

      <div className="topbar-right">
        <ThemeSwitcher />
        <AnnouncementsBell />
        {canAccessAutoProjects && <NotificationsMenu />}

        <div className="credits-display">
          <Zap size={20} />
          <div>
            <div className="credits-amount">{isLoading ? '...' : credits.toLocaleString()}</div>
            <div className="credits-label">Crédits</div>
          </div>
        </div>

        <Link to="/dashboard/compte/credits" className="btn btn-primary btn-sm">
          <Plus size={16} />
          Acheter
        </Link>
      </div>
    </div>
  )
}
